<template>
  <div class="all">
    <div class="head" >
        <div style="margin-left: 100px;margin-top: 5px; line-height: 40px">名称：
          <el-input placeholder="请输入企业中英文名称/相关产品信息/简介/经营范围" @keyup.enter="search" style="width: 600px" v-model="companyName" clearable></el-input>
          <el-checkbox style="margin-left: 40px; margin-right: 40px;" v-model="belongJoySun" label="卓盛客户" size="large"/>
          <el-button type="primary" style="width: 100px;" @click="search">搜索</el-button>
          <el-button type="primary" style="width: 100px;" @click="restButton" plain>重置</el-button>
          <el-button style="width: 100px;" @click="showSearch = !showSearch" plain>筛选</el-button>
        </div>

      <div v-show="showSearch" style="margin-left: 72px;">所属地区：
      <el-cascader :props="props" :options="catalogWithCity" style="width: 400px"
                   :show-all-levels="false" placeholder="选择地区" v-model="city"
                   clearable filterable/>
      </div>

      <div v-show="showSearch" style="margin-left: 100px; line-height: 30px; display: flex">行业：
        <el-checkbox-group v-model="industryList">
          <el-checkbox v-for="item in industryTypeList" :label="item.value" style="margin-left: 10px;">{{item.label}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div v-show="showSearch" style="margin-left: 100px;margin-top: 5px; line-height: 30px">
        <el-row>
        <div style="width: 3%;">产品：</div>
          <div style="width: 97%">
            <div class="productTitle" v-for="item in productList">
              <div class="productType">{{ item.name }}</div>
              <div style="width: 100%">
                  <el-checkbox v-model="checkBoxData" v-for="obj in item.children" class="el-checkbox1" :label="obj.id">{{ obj.name }}</el-checkbox>
              </div>
            </div>

          </div>
        </el-row>

      </div>
      <div v-show="showSearch" style="margin-left: 100px;margin-top: 5px; line-height: 30px; display: flex">案例：
        <el-checkbox-group v-model="anli">
          <el-checkbox style="margin-left: 10px;" label="Embodiment">实施方案</el-checkbox>
          <el-checkbox label="detail">详细</el-checkbox>
          <el-checkbox label="simple">简单</el-checkbox>
          <el-checkbox label="video">视频</el-checkbox>
          <el-checkbox label="case_video">案例视频</el-checkbox>
          <el-checkbox label="technology_and_after_problem">技术&售后问题方案</el-checkbox>
        </el-checkbox-group>

      </div>
    </div>

    <div class="list" v-loading="loading">
      <div v-for="item in customerInfoList">
      <div class="list-item" @click="showCustomerDetail(item.id)">
        <el-image style="height: 240px; width: 300px" :src="item.url" />
        <p class="customerName"><b>{{item.name}}</b></p>
        <p><b>{{item.english_name}}</b></p>
        <p class="customerIntroduce">{{item.product_info}}</p>
      </div>
      </div>
    </div>

    <div style="height:32px;display: flex;justify-content: flex-end;">
      <el-pagination background layout=" sizes, total, prev, pager, next,"
                     :page-sizes="[20,30,40]"
                     :current-page="currentPage"
                     v-model:page-size="pageSize"
                     :total="total"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :small="false"/>
    </div>

  </div>
</template>

<script>


export default {
  name: "CaseShow.vue",

  data() {
    return {
      parentData: {},
      formData:[],
      companyName:'',
      customerId:'',
      pageSize:20,
      currentPage:1,
      total:0,
      belongJoySun:false,
      aboutCase:false,
      loading:false,
      showSearch:false,
      city:[],
      customerInfoList:[],
      catalogWithCity:[],
      industryList:[],
      industryTypeList:[],
      anli:[],
      checkBoxData:[],
      productList:[],
      platformList:[],
      designList:[],
      exchangeList:[],
      analysisList:[],
      toolList:[],
      props: {
        emitPath:false,
        multiple: true,
        checkStrictly:true,
        expandTrigger: 'hover',
        value: 'value',
        label: 'label'
      }
    }

  },

  created() {
    this.getCustomerInfo();
    this.getInChinaCity();
    this.getIndustryList();
    this.getCaseProduct();
  },
  methods:{
    //获取所有客户基本信息 id 图片 名字 简介
    async getCustomerInfo(){
      this.loading = true;
      let page = {
        pageSize: this.pageSize,
        currentPage: this.currentPage
      }
      let res = await this.$http('caseLibraryService.getCustomerInfo',page)
      this.customerInfoList = res.customerList;
      this.total = res.total;
      this.loading = false;
    },
    showCustomerDetail(id){
      this.$store.dispatch('core/openWindow', {
        component: 'crm/CaseCompanyDetails',
        parentData: id,
        name: '企业详情',
        max: true
      })
    },
    //搜索按钮
    async search(){
      this.loading = true;
      this.customerInfoList = [];
      let params = {
        companyName :this.companyName,
        belongJoySun: this.belongJoySun,
        industryList: this.industryList,
        checkBoxData: this.checkBoxData,
        city: this.city,
        anli: this.anli,
        pageSize: this.pageSize,
        currentPage: this.currentPage
      }
      let res = await this.$http('caseLibraryService.caseSearch',params)
      this.customerInfoList = res.companyList;
      this.total = res.total;
      if(this.customerInfoList.length === 0){
        this.$message.error("未找到相关企业数据")
      }
      this.loading = false;
    },
    //重置按钮
    restButton(){
      this.companyName = '';
      this.belongJoySun = false;
      this.city = [];
      this.industryList = [];
      this.checkBoxData = [];
      this.anli = [];

      this.search();
    },

    //获取行业类型
    async getIndustryList() {
      this.industryTypeList = await this.$http('caseLibraryService.getIndustryList')
    },
    //获取国内城市数据
    async getInChinaCity(){
      this.catalogWithCity = await this.$http('caseLibraryService.getCatalogCity')
    },
    //获取所有产品
    async getCaseProduct(){
      this.productList = await this.$http('caseLibraryService.getProductList')
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    //改变国内外 city重新赋值
    dataClear(){
      this.city = ""
    },
  },



}
</script>

<style scoped>
.head{
  border: #ececec solid;
  width: 99%;
  border-radius: 10px;
  margin-left: 10px;
  margin-top: 10px;
  position: absolute;
  z-index: 9999;
  background-color: whitesmoke;
}
.productTitle{
  display: flex
}
.productType{
  width: 100px;
  text-align: right;
}

.el-checkbox1{
  margin-left: 10px
}
.list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5.5%;
  margin-left: 5px;
  overflow: auto;
  height: 83%;
}

.list .list-item {
  width: 300px;
  min-height: 300px;
/*  border: 1px solid red;*/
  margin-left: 20px;
  margin-bottom: 10px;
}
.list-item el-img{
  height:500px;
  width:300px;
}
.customerName{
  font-size: 18px;

}
.customerIntroduce{
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

}

.all{
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>